import 'jquery-ui';

import '~bootstrap/dist/js/bootstrap.bundle.min.js';

import '../include/add-class-plugin.js';
import '../include/anchors.js';
import '../include/barcode-scanner.js';
import initCustomForms from '../include/CustomForms.js';
import '../include/datepicker.js';
import '../include/dragscroll.js';
import '../include/endless-scroller.js';
import '../include/fancybox.js';
import '../include/fitvids.js';
import '../include/focus-class.js';
import '../include/hammer.js';
import '../include/jquery.scrolling-tabs.min.js';
import '../include/open-close.js';
import '../include/popups.js';
import '../include/responsive-layout-helper.js';
import '../include/retina-picturefill.js';
import '../include/running-line.js';
import '../include/slide-show.js';
import '../include/sticky-box.js';
import './retina-cover.js';

jQuery(() => {
  initCheckedClasses();
  initFocusClass();
  initDatepicker();
  initRetinaCover();
  initCustomForms();
  initTermsAndConditionsLinks();
  initDistributionSchemaLink();
  initSlickCarousel();
  initFancybox();
  initRemoveListItem();
  initSlideShow();
  initFitVids();
  initBsHelpers();
  initCustomerPricesAndDiscounts();
  initBrowserDetect(false, false);
  initBackToTop();
  initTooltips();
  initCartItemsCheck();
  initAlertMessage();
  initLazyVideo({ autoload: true });
  initRunningLine();
});

function initAlertMessage() {
  const alert = document.getElementById('alert-message');
  if (alert) {
    const alertCookie = `alert_closed_${alert.getAttribute('data-id')}`;
    if (!getCookie(alertCookie)) {
      alert.classList.remove('d-none');
      const closeBtns = alert.querySelectorAll('.close');
      for (const btn of closeBtns) {
        btn.addEventListener('click', () => {
          setCookie(alertCookie, 1);
        });
      }
    }
  }

  function setCookie(name) {
    const d = new Date();
    const expires = `expires=${new Date(d.getFullYear(), d.getMonth(), d.getDate(), 24, 59, 59)}`;
    document.cookie = `${name}=1;${expires};path=/; SameSite=Strict;`;
  }

  function getCookie(cname) {
    const name = `${cname}=`;
    const decodedCookie = decodeURIComponent(document.cookie);
    const ca = decodedCookie.split(';');
    for (let i = 0; i < ca.length; i++) {
      let c = ca[i];
      while (c.charAt(0) === ' ') {
        c = c.substring(1);
      }
      if (c.indexOf(name) === 0) {
        return c.substring(name.length, c.length);
      }
    }
    return '';
  }
}

/*
 * Browser Detect script
 */
function initBrowserDetect(addVersionOS, addBrowserMinorVersion) {
  window.BrowserDetect = (function () {
    // script settings
    const options = {
      osVersion: addVersionOS,
      minorBrowserVersion: addBrowserMinorVersion,
    };

    // browser data
    const browserData = {
      browsers: {
        edge: uaMatch(/ Edge\/([0-9\.]*)/),
        chrome: uaMatch(/Chrome\/([0-9\.]*)/),
        firefox: uaMatch(/Firefox\/([0-9\.]*)/),
        safari: uaMatch(/Version\/([0-9\.]*).*Safari/),
        opera: uaMatch(/Opera\/.*Version\/([0-9\.]*)/, /Opera\/([0-9\.]*)/),
        msie: uaMatch(/MSIE ([0-9\.]*)/, /Trident.*rv:([0-9\.]*)/),
      },
      engines: {
        edgehtml: uaContains(' Edge\/'),
        webkit: uaContains('AppleWebKit'),
        trident: uaMatch(/(MSIE|Trident)/),
        gecko: uaContains('Gecko'),
        presto: uaContains('Presto'),
      },
      platforms: {
        win: uaMatch(/Windows NT ([0-9\.]*)/),
        mac: uaMatch(/Mac OS X ([0-9_\.]*)/),
        linux: uaContains('X11', 'Linux'),
      },
    };

    // perform detection
    const ua = navigator.userAgent;
    const detectData = {
      platform: detectItem(browserData.platforms),
      browser: detectItem(browserData.browsers),
      engine: detectItem(browserData.engines),
    };

    // private functions
    function uaMatch() {
      const regs = Array.prototype.slice.apply(arguments);
      return function () {
        for (var i = 0, result; i < regs.length; i++) {
          result = regs[i].exec(ua);
          if (result) {
            return result[1];
          }
        }
      };
    }
    function uaContains(word) {
      const words = Array.prototype.slice.apply(arguments);
      return function () {
        for (let i = 0; i < words.length; i++) {
          if (ua.indexOf(words[i]) < 0) {
            return;
          }
        }
        return true;
      };
    }
    function detectItem(items) {
      const detectedItem = null; let itemName; let
        detectValue;
      for (itemName in items) {
        if (items.hasOwnProperty(itemName)) {
          detectValue = items[itemName]();
          if (detectValue) {
            return {
              name: itemName,
              value: detectValue,
            };
          }
        }
      }
    }

    // add classes to root element
    (function () {
      // helper functions
      const addClass = function (cls) {
        const html = document.documentElement;
        html.className += (html.className ? ' ' : '') + cls;
      };
      const getVersion = function (ver) {
        return typeof ver === 'string' ? ver.replace(/\./g, '_') : 'unknown';
      };

      // add classes
      if (detectData.platform) {
        addClass(detectData.platform.name);
        if (options.osVersion) {
          addClass(`${detectData.platform.name}-${getVersion(detectData.platform.value)}`);
        }
      }
      if (detectData.engine) {
        addClass(detectData.engine.name);
      }
      if (detectData.browser) {
        addClass(detectData.browser.name);
        addClass(`${detectData.browser.name}-${parseInt(detectData.browser.value, 10)}`);
        if (options.minorBrowserVersion) {
          addClass(`${detectData.browser.name}-${getVersion(detectData.browser.value)}`);
        }
      }
    }());

    // export detection information
    return detectData;
  }());
}

// handle flexible video size
function initFitVids() {
  jQuery('#content').fitVids();
}

// fade gallery init
function initSlideShow() {
  jQuery('.carousel-details-js').fadeGallery({
    slides: '.slide',
    btnPrev: '.btn-prev',
    btnNext: '.btn-next',
    touch: false,
    generatePagination: '.pagination-carousel',
    pauseOnHover: false,
  });
}

// remove list item
function initRemoveListItem() {
  jQuery('.cart-list').on('click', '.close-btn', function (e) {
    e.preventDefault();
    jQuery(this).closest('li').remove();
  });
}

// lightbox init
window.initFancybox = function initFancybox() {
  jQuery('a.lightbox-product').fancybox({
    parentEl: 'section.aside-section',
    baseClass: 'details-lightbox',
    animationEffect: false,
    closeExisting: true,
    touch: false,
    margin: [50, 0],
    backFocus: false,
    beforeLoad(instance, current) {
      const productId = current.src.substring(1);
      const detailPageTemplate = Hogan.compile(jQuery('#product-detail-template').text());
      const productDetails = jQuery('.algoliaplus-product-details');
      const productData = window.Verwimp.loadedProducts[productId];
      if (!productData) {
        return;
      }
      productDetails.html(detailPageTemplate.render(productData));
    },
    afterShow(instance, current) {
      current.opts.$orig.closest('.main-products-item').toggleClass('product-active');

      if (window.jcf) {
        jcf.refreshAll('.fancybox-container');
      }

      initFancyboxGallery();
      updateFavoriteButtons();
      updateCatalogCartButtons();
      initProductDetailCartButton();
      initTooltips();
      // https://github.com/mikejacobson/jquery-bootstrap-scrolling-tabs#readme
      $('.list-group-product-detail').scrollingTabs({
        bootstrapVersion: 4,
        enableSwiping: true,
        disableScrollArrowsOnFullyScrolled: true,
        leftArrowContent: [
          '<div class="scrtabs-tab-scroll-arrow scrtabs-tab-scroll-arrow-left">',
          '  <button class="scrtabs-click-target" type="button">',
          '    <i class="ti ti-arrow-circle-left"></i>',
          '  </button>',
          '</div>',
        ].join(''),
        rightArrowContent: [
          '<div class="scrtabs-tab-scroll-arrow scrtabs-tab-scroll-arrow-right">',
          '  <button class="scrtabs-click-target" type="button">',
          '    <i class="ti ti-arrow-circle-right"></i>',
          '  </button>',
          '</div>',
        ].join(''),
      });
      const priceMode = localStorage.getItem('Verwimp.catalog.price-mode');
      if (!priceMode || priceMode === 'retail') {
        $('.specs-block').trigger('click');
      }
      $('#related-products').on('click', '.go-to-product', goToProduct);
    },
    afterClose(instance, current) {
      current.opts.$orig.closest('.main-products-item').toggleClass('product-active');
    },
  });

  jQuery('a.product-gallery').fancybox({
    parentEl: 'body',
    baseClass: 'product-gallery-lightbox',
    touch: false,
    animationEffect: false,
    margin: [50, 0],
    thumbs: {
      autoStart: true,
      axis: 'x',
    },
    onThumbsShow(instance, current) {
      instance.Thumbs.$grid.appendTo(instance.$refs.inner);
    },
  });

  jQuery('.fancybox-link').fancybox({
    parentEl: '#wrapper',
    baseClass: 'fancybox-popups',
    touch: false,
    animationEffect: false,
    margin: [50, 0],
    afterShow() {
      jcf.refreshAll('.fancybox-container');
    },
  });

  jQuery('.fancybox-cart-link').fancybox({
    parentEl: 'section.aside-section',
    baseClass: 'fancybox-cart',
    touch: false,
    animationEffect: false,
    margin: [50, 0],
    afterShow() {
      jcf.refreshAll('.fancybox-container');
    },
  });

  jQuery('.open-lightbox').fancybox({
    parentEl: '#wrapper',
    baseClass: 'inform-fancybox-popups fancybox-popups',
    touch: false,
    animationEffect: false,
    margin: [50, 0],
  });

  jQuery('.auto-open-lightbox').each(function () {
    jQuery.fancybox.open(jQuery(this), {
      parentEl: '#wrapper',
      baseClass: 'inform-fancybox-popups fancybox-popups',
      touch: false,
      animationEffect: false,
      margin: [50, 0],
    });
  });

  jQuery('.close-popup').on('click', () => {
    $.fancybox.close();
  });
};

// slick init
function initSlickCarousel() {
  if (jQuery('.products-carousel').length) {
    jQuery(".post-slider").slick({
      slidesToScroll: 1,
      rows: 0,
      prevArrow: '<button class="slick-prev ti-angle-left"></button>',
      nextArrow: '<button class="slick-next ti-angle-right"></button>',
      fade: true,
      autoplay: true,
      speed: 1000,
    });
  }
}

function initRetinaCover() {
  jQuery('.bg-stretch').retinaCover();
}

// add class when element is in focus
function initFocusClass() {
  jQuery('.cart-row, .main-products-item').addFocusClass({
    focusClass: 'child-input-focused',
    element: '.form-control',
  });
}

function initDatepicker() {
  jQuery('input.datepicker').each(function () {
    const settings = {
      dateFormat: 'yy-mm-dd',
      firstDay: 1,
    };

    if (jQuery(this).data('settings')) {
      jQuery.extend(true, settings, jQuery(this).data('settings'));
    }

    jQuery(this).uiDatepicker(settings);
  });
}

// checked classes when element active
window.initCheckedClasses = function initCheckedClasses() {
  const checkedClass = 'input-checked'; const
    parentCheckedClass = 'input-checked-parent';
  const pairs = [];

  jQuery('label[for]').each((index, label) => {
    if (!label.htmlFor) return;

    const input = jQuery(`#${label.htmlFor}`);
    label = jQuery(label);

    // click handler
    if (input.length && !label.attr('data-checked-classes-init')) {
      label.attr('data-checked-classes-init', true);
      pairs.push({ input, label });
      input.bind('click change', () => {
        if (input.is(':radio')) {
          jQuery.each(pairs, (index, pair) => {
            refreshState(pair.input, pair.label);
          });
        } else {
          refreshState(input, label);
        }
      });
      refreshState(input, label);
    }
  });

  // refresh classes
  function refreshState(input, label) {
    if (input.is(':checked')) {
      input.parent().addClass(parentCheckedClass);
      label.addClass(checkedClass);
    } else {
      input.parent().removeClass(parentCheckedClass);
      label.removeClass(checkedClass);
    }
  }
};

function initTermsAndConditionsLinks() {
  jQuery('.terms-and-conditions a').attr('target', '_blank');
}

window.initDistributionSchemaLink = function initDistributionSchemaLink() {
  jQuery('.distribution-schema a').attr('target', '_blank');
};

function initBsHelpers() {
  function refreshScrollable($scrollable) {
    if (window.jcf) {
      jcf.refresh($scrollable);
    }
  }

  function initScrollable() {
    const $collapse = jQuery(this);
    const $scrollableChildren = $collapse.find('.jcf-scrollable');
    const $scrollableParents = $collapse.parents('.jcf-scrollable');

    if ($scrollableChildren.length) {
      refreshScrollable($scrollableChildren);
    }

    if ($scrollableParents.length) {
      refreshScrollable($scrollableParents);
    }
  }

  jQuery('.collapse')
    .on('shown.bs.collapse', initScrollable)
    .on('hidden.bs.collapse', initScrollable);
}

function initCustomerPricesAndDiscounts() {
  let loaded = false;
  jQuery('.customer-prices-and-discounts-link').fancybox({
    parentEl: '#wrapper',
    baseClass: 'fancybox-popups',
    touch: false,
    animationEffect: false,
    margin: [50, 0],
    afterShow() {
      if (window.jcf) {
        jcf.refreshAll('.fancybox-container');
      }

      if (!loaded) {
        loaded = true;
        jQuery.ajax('/index.php?p=actions/verwimp-portal/customers/get-prices-and-discounts', {})
          .done((data) => {
            const customerListTemplate = Hogan.compile(jQuery('#prices-and-discounts-template').text());
            jQuery('#customer-prices-and-discounts .output').html(customerListTemplate.render({ pricesAndDiscounts: data.pricesAndDiscounts }));
          });
      }
    },
  });
}

function initBackToTop() {
  const $btt = $('.back-to-top');
  $btt.addClass('js-invisible').removeClass('js-visible');
  $(document).scroll(function () {
    const y = $(this).scrollTop();

    if (y > 500) {
      $btt.addClass('js-visible js-animate').removeClass('js-invisible');
    } else {
      $btt.addClass('js-invisible').removeClass('js-visible');
    }
  });
}

window.initTooltips = function initTooltips() {
  jQuery('[data-toggle="tooltip"]').tooltip();
};

// Expose to global scope
window.initCartItemsCheck = function initCartItemsCheck() {
  const customerCartHasItems = localStorage.getItem('customerCartHasItems');
  const dropshipmentCartHasItems = localStorage.getItem('dropshipmentCartHasItems');
  if (window.Verwimp.cart) {
      const { cartType, totalQty } = window.Verwimp.cart;
      if (cartType === 'customer') {
          if (customerCartHasItems === 'true') {
              jQuery('#cart-count').html(totalQty);
          } else {
              jQuery('#cart-count').html('');
          }
      } else if (dropshipmentCartHasItems === 'true') {
              jQuery('#cart-count').html(totalQty);
          } else {
              jQuery('#cart-count').html('');
          }
  }
};

function playIframe(iframe) {
  let command = {};

  if (iframe.src.indexOf('vimeo.com') > -1) {
    command = {
      method: 'play',
      value: 'true',
    };
  } else {
    command = {
      event: 'command',
      func: 'playVideo',
    };
  }

  iframe.contentWindow.postMessage(JSON.stringify(command), '*');
}

function initLazyVideo(opt) {
  // Medium Quality: http://img.youtube.com/vi/{video-id}/mqdefault.jpg (320Г—180 pixels)
  // High Quality: http://img.youtube.com/vi/{video-id}/hqdefault.jpg (480Г—360 pixels)
  // Standard Definition (SD): http://img.youtube.com/vi/{video-id}/sddefault.jpg (640Г—480 pixels)
  // Maximum Resolution: http://img.youtube.com/vi/{video-id}/maxresdefault.jpg (1920Г—1080 pixels)
  // Vimeo: https://i.vimeocdn.com/video/{video-id}

  // detect device type
  const isTouchDevice = /Windows Phone/.test(navigator.userAgent) || ('ontouchstart' in window) || window.DocumentTouch && document instanceof DocumentTouch;
  const lazyOpt = jQuery.extend({}, {
    $videoPlaceholders: jQuery('[data-embed]'),
    autoplay: false,
    autoload: !!isTouchDevice,
  }, opt);
  const { $videos } = opt;

  lazyOpt.$videoPlaceholders.each(function (index, holder) {
    const $holder = jQuery(this);
    const $btnPlay = $holder.find('.play-button');
    const embed = $holder.data('src') ? '' : $holder.data('embed');
    const type = $holder.data('type');
    const domen = type === 'youtube' ? 'https://www.youtube.com/embed/' : type === 'vimeo' ? 'https://player.vimeo.com/video/' : $holder.data('src');

    $btnPlay.on('click', (e) => {
      e.preventDefault();
    });

    if (lazyOpt.autoplay || lazyOpt.autoload) {
      createVideoEl();
    } else {
      $btnPlay.on('click', () => {
        opt.autoplay = true;
        createVideoEl();

        $holder.addClass('play-pressed');
      });
    }

    function createVideoEl() {
      const videoUrl = domen + embed;
      const iframeUrl = `${domen + embed
      }?${type === 'youtube' ? 'rel=0&showinfo=0&enablejsapi=1' : 'byline=0&portrait=0&api=1'}&playsinline=1`;

      $holder.addClass('lazy-video-loading');

      const $iframe = jQuery(
        `<iframe class="embed-responsive-item" src="${iframeUrl}" frameborder="0" allowfullscreen="" allow="autoplay; encrypted-media;"></iframe>`,
      );

      $iframe.on('load', (e) => {
        $btnPlay.on('click', () => {
          playIframe(e.currentTarget);

          $holder.addClass('play-pressed');
        });

        if (opt.autoplay) {
          playIframe(e.currentTarget);

          $holder.addClass('play-pressed');
        }

        $holder.removeClass('lazy-video-loading');
      });

      $holder.append($iframe);

      $holder.addClass('lazy-ready');
    }
  });
}

function initRunningLine() {
  jQuery('.line-box-right').marquee({
    line: '.line',
    animSpeed: 30,
    mask: '.mask',
    direction: 'right',
  });

  jQuery('.line-box-left').marquee({
    line: '.line',
    animSpeed: 30,
    mask: '.mask',
    direction: 'left',
  });
}
